import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';

import { IRootScopeService, ITimeoutService } from 'angular';
import { HippoApiService } from 'services/hippoApi';
import { getPaymentMethod } from 'common/source/utilities/policyInfoHelper';

import { getPaymentFrequency } from 'common/source/utilities/policyInfoHelper';
import { ng } from '@uirouter/angularjs/lib/angular';

const module = angular.module('payment-frequency-section', []);

interface PaymentFrequencySectionController extends angular.IStrictController {
    policyInfo: CustomerPolicyInfo;
    pastPayments: Array<PastCharge>;
    downloadReceipt: (payment: Payment) => void;
    formatAsDollarsWithoutZeroCents: (sum: number) => string;
    isSelected: (freq: PaymentFrequency) => boolean;
    selectedPaymentFrequency: PaymentFrequency;
    selectFrequency: (freq: PaymentFrequency) => void;
    showSuccessMessage: boolean;
    frequencyOptions: Array<string>;
    getValueToShow: (freq: PaymentFrequency) => string;
    changePaymentMethod: ($event: ng.IAngularEvent, name: PaymentMethod) => void;
    updatePaymentMethod: (name: PaymentMethod) => void;
    selectedPaymentMethod: PaymentMethod;
}

type Frequencies = { [key in PaymentFrequency]: string };
const frequencies: Frequencies = {
    annually: 'Annually',
    semi_annually: '2 Payments Per Year',
    quarterly: '4 Payments Per Year',
    monthly: 'Monthly'
};

module.component('paymentFrequencySection', {
    bindings: {
        policyInfo: '<',
        paymentMethod: '<'
    },
    template: template,
    controller: function(
        this: PaymentFrequencySectionController,
        $element: angular.IAugmentedJQuery,
        $timeout: ITimeoutService,
        hippoApiService: HippoApiService,
        $scope: angular.IScope,
        $rootScope: IRootScopeService
    ) {
        this.$onInit = () => {
            this.selectedPaymentFrequency = getPaymentFrequency(this.policyInfo);
            this.frequencyOptions = getFrequencyOptions(getPaymentMethod(this.policyInfo));
            $rootScope.$on('paymentMethodUpdateSuccess', this.changePaymentMethod);
        };

        const getFrequencyOptions = (name?: PaymentMethod) => {
            const selectedPaymentMethod = name || getPaymentMethod(this.policyInfo);

            if (selectedPaymentMethod === 'escrow') {
                return [getPaymentFrequency(this.policyInfo)];
            }
            return Object.keys(frequencies);
        };

        this.changePaymentMethod = ($event: ng.IAngularEvent, name: PaymentMethod) => {
            this.frequencyOptions = getFrequencyOptions(name);
        };

        this.getValueToShow = (op) => frequencies[op];
        this.isSelected = (freq: PaymentFrequency) => {
            return this.selectedPaymentFrequency === freq;
        };

        this.updatePaymentMethod = (name: PaymentMethod) => {
            this.selectedPaymentMethod = name;
        };

        this.selectFrequency = (freq) => {
            if (freq === getPaymentFrequency(this.policyInfo)) {
                return;
            }

            this.selectedPaymentFrequency = freq;

            const policyNumber = this.policyInfo.id;

            const policyInfoUpdate: CustomerPolicyInfoUpdate = {
                checkout_data: {
                    payment_frequency: this.selectedPaymentFrequency
                }
            };

            hippoApiService
                .updateCustomerPolicy(policyNumber, policyInfoUpdate)
                .then((result) => {
                    this.showSuccessMessage = true;
                    $rootScope.$emit('updatedCustomerPolicyInfos');
                })
                .catch(() => {
                    // TODO show error message
                });
        };
    }
});

export { module };
